class detail {
    constructor(
        conceptoId,
        cscostoId,
        maximo,
        orden,
        resto

    ) {
        this.conceptId = conceptoId;
        this.cscostoId = cscostoId;
        this.maximo = maximo;
        this.orden = orden;
        this.resto = resto;
        this.restoTable = resto === true ? '✔️' : ""; 

    }
    static fromJson({
        conceptoId,
        cscostoId,
        maximo,
        num,
        resto
    }) {
    return new detail(
        conceptoId,
        cscostoId,
        maximo,
        num,
        resto
        );
    }
}
export default detail;
